export const initializeTimelineList = () => {
  document
    .querySelectorAll(
      '.timeline-list li',
    )
    .forEach((item) => {
      item.dataset.aos = 'fade-up';
    });
};
